import classNames from 'classnames'
import React, { FC } from 'react'

import s from './RadioOption.scss'
import Tick from './tick.svg'

type RadioOptionProps = {
  name: string
  value: string
  checked: boolean
  onChange: () => void
  label: string
  dataHook?: string
  className?: string
}

export const RadioOption: FC<RadioOptionProps> = ({ name, value, checked, onChange, label, dataHook, className }) => (
  <label className={classNames(s.option, { [s.optionSelected]: checked }, className)} data-hook={dataHook}>
    <input type="radio" name={name} value={value} checked={checked} onChange={onChange} className={s.radioInput} />
    <span className={s.indicator}>{checked && <Tick />}</span>
    <span className={s.label}>{label}</span>
  </label>
)
